export default __webpack_public_path__ + "static/media/cpm.dccbd495.png";